export function extractJsonFromResponse(content: string): any {
  // Match everything between the first { and last } OR first [ and last ]
  const jsonMatch = content.match(/(\{[\s\S]*?\}|\[[\s\S]*?\])/);
  if (!jsonMatch) return null;

  try {
    return JSON.parse(jsonMatch[0]);
  } catch (error) {
    console.error('Error parsing JSON:', error);
    return null;
  }
}
